import React from "react";
import {
  FiCompass,
  FiServer,
  FiRepeat,
  FiShield,
  FiZap,
  FiCpu,
} from "react-icons/fi";
import {
  ServicesSectionWrapper,
  ServicesInner,
  ServicesTitle,
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceTitle,
  ServiceText,
} from "./ServicesElements";

const services = [
  {
    title: "Strategy",
    text: "Roadmaps, budgets, and priorities aligned to how your team works.",
    Icon: FiCompass,
  },
  {
    title: "Infrastructure",
    text: "Managed networks and endpoints that reduce downtime and keep work flowing.",
    Icon: FiServer,
  },
  {
    title: "Migrations",
    text: "Clean cutover for email, files, and systems that doesn't disrupt your work.",
    Icon: FiRepeat,
  },
  {
    title: "Security",
    text: "Practical controls for identity, devices, and data that enable innovation and growth.",
    Icon: FiShield,
  },
  {
    title: "Automations",
    text: "Workflow improvements that reduce manual steps and ensure consistent results.",
    Icon: FiZap,
  },
  {
    title: "AI",
    text: "Applied AI that speeds decisions, reduces busywork, and scales expertise.",
    Icon: FiCpu,
  },
];

const ServicesSection = () => {
  return (
    <ServicesSectionWrapper id="services">
      <ServicesInner>
        <ServicesTitle>Services</ServicesTitle>
        <ServicesGrid>
          {services.map(({ title, text, Icon }) => (
            <ServiceCard key={title}>
              <ServiceIcon aria-hidden="true">
                <Icon />
              </ServiceIcon>
              <ServiceTitle>{title}</ServiceTitle>
              <ServiceText>{text}</ServiceText>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </ServicesInner>
    </ServicesSectionWrapper>
  );
};

export default ServicesSection;
